import { Dispatch, SetStateAction } from 'react';

import { FamilyMember } from 'enrollment/features/Shared';
import { DependentsResponseDto } from 'theSource/features/FamilyMembers/types';
import { SubscriberFieldsDto } from 'theSource/types';
import { DecisionIQFamilySelectListStyled } from '../../DecisionIQStyled';
import { DecisionIQSurveyQuestionDto } from 'enrollment/queries';
import { PsCheckboxTuner } from 'stencilSetup';

interface ChronicIllnessQuestionsProps {
  questions: DecisionIQSurveyQuestionDto;
  showChronicDeps: boolean[] | undefined;
  setShowChronicDeps: Dispatch<SetStateAction<boolean[] | undefined>>;
  dependents?: DependentsResponseDto;
  subscriber?: SubscriberFieldsDto;
  onDependentSelect: (e: any) => void;
}

export const ChronicIllnessQuestions = ({
  questions,
  showChronicDeps,
  setShowChronicDeps,
  dependents,
  subscriber,
  onDependentSelect,
}: ChronicIllnessQuestionsProps) => {
  const handleQuestionSelect = (e: any) => {
    if (!showChronicDeps || e.target.tagName !== 'INPUT') {
      return;
    }
    const index = Number(e.target.id.split('-')[2]);
    const newShowChronicDeps = [...showChronicDeps];
    newShowChronicDeps[index] = !newShowChronicDeps[index];
    setShowChronicDeps(newShowChronicDeps);

    // if the user unchecks the question, we should uncheck their values
    // original value would still be true
    if (showChronicDeps[index]) {
      onDependentSelect(e.target.id);
    }
  };

  return (
    <DecisionIQFamilySelectListStyled data-testid="chronic-illnesses">
      {questions.options.map((option, index) => (
        <div className="in-drawer" key={index}>
          <PsCheckboxTuner
            data-testid={`chronic-checkbox-${index}`}
            inputId={`chronic-checkbox-${index}`}
            name={`chronic-checkbox-${index}`}
            label={String(option.label)}
            onClick={handleQuestionSelect}
            checked={showChronicDeps && showChronicDeps[index]}
            className="mobile-drawer-checkbox"
          />
          {showChronicDeps && showChronicDeps[index] && (
            <div className="py-3 ml-md-4_5">
              {/* Cannot use "isYou" since that makes the checkmark disabled, which we don't want */}
              <FamilyMember
                name="You"
                onChangeKey={`chronic-${option.value}-emp`}
                onChangeWithKey={onDependentSelect}
                profile={subscriber?.subscriber_profile}
                selected={option['is_checked?'].includes('emp')}
              />
              {dependents &&
                dependents.data.dependents.map((dependent, index) => (
                  <FamilyMember
                    key={index}
                    name={dependent.first_name}
                    onChangeKey={`chronic-${option.value}-${dependent.id}`}
                    onChangeWithKey={onDependentSelect}
                    profile={dependent.dependent_profile}
                    selected={option['is_checked?'].includes(
                      String(dependent.id)
                    )}
                  />
                ))}
            </div>
          )}
        </div>
      ))}
    </DecisionIQFamilySelectListStyled>
  );
};
